module.exports = __webpack_public_path__ + "static/media/Pescado.c69466cb.png";